import Grid from "@mui/material/Grid";
import WorkItemBulkOperationResponsibility from "../fields/WorkItemBulkOperationResponsibility";
import WorkItemBulkOperationResource from "../fields/WorkItemBulkOperationResource";
import Button from "@mui/material/Button";
import { GetAutocompleteResult } from "hooks/work-items/useWorkItemAutocompleteResource";
import useBulkOperationAutoCompleteResource from "hooks/work-items/useBulkOperationAutoCompleteResource";
import { useState, useEffect } from "react";
import { GridRowSelectionModel } from "@mui/x-data-grid-pro";

interface IBulkUpdateOpertionsResponsibilities {
    idSuffix: string,
    responsibilityOptions?: any[],
    selectedWorkSpaceIds: number[],
    selectedResponsibilityIds?: number[],
    selectedWorkItems: GridRowSelectionModel,
    saveInProgress?:boolean,
    OnReviewConfirmClick: (responsibility: number[], resource: string | GetAutocompleteResult) => void
}

const BulkUpdateOpertionsResponsibilities = (props: IBulkUpdateOpertionsResponsibilities) => {

    const [bulkUpdateResourceDisabled, setBulkUpdateResourceDisabled] = useState<boolean>(false);
    const [selectedBulkOperationResponsibility, setSelectedBulkOperationResponsibility] = useState<number[]>([]);
    const [selectedBulkOperationResource, setSelectedBulkOperationResource] = useState<string | GetAutocompleteResult | null>(null);
    const [bulkUpdateResourceSearchValue, setBulkUpdateResourceSearchValue] = useState('');
    const [updateGridButtonDisabled, setUpdateGridButtonDisabled] = useState<boolean>(true);
    const [assignAsPrimary, setAssignAsPrimary] = useState<boolean>(true);
    const [assignResourceOnInProgress, setAssignResourceOnInProgress] = useState<boolean>(false);
    const [workspaceIds, setWorkspaceIds] = useState<number[]>([]);

    const [
        bulkOperationResources,
        loadingBulkOperationsResources,
        errorBulkOperationsResources
    ] = useBulkOperationAutoCompleteResource(
        props.selectedResponsibilityIds ?? [0],
        workspaceIds,
        bulkUpdateResourceSearchValue
    );

    // const handleResponsibilityChange = (selectedBulkOperationResponsibility: number[]) => {
    //     if (selectedBulkOperationResponsibility.length > 0) {
    //         setBulkUpdateResourceDisabled(false);
    //         setSelectedBulkOperationResponsibility(selectedBulkOperationResponsibility);
    //     } else {
    //         setBulkUpdateResourceDisabled(true);
    //         setSelectedBulkOperationResponsibility([]);
    //     }
    //     setSelectedBulkOperationResource(null);
    //     setBulkUpdateResourceSearchValue('');
    //     handleUpdateGridButtonVisibility(null);
    // };

    const handleBulkOperationChangeResource = (e: any, newValue: string | GetAutocompleteResult | null) => {
        if (newValue !== null && typeof newValue === 'object' && newValue.hasOwnProperty('userId')) {
            const selectedValue = newValue as GetAutocompleteResult;
            setSelectedBulkOperationResource(selectedValue);
        }
        else {
            setSelectedBulkOperationResource(null);
            setBulkUpdateResourceSearchValue('');
        }
        handleUpdateGridButtonVisibility(newValue);
    }

    const handleUpdateGridButtonVisibility = (resourceValue: any) => {
        if (!props.selectedResponsibilityIds || props.selectedResponsibilityIds.length <= 0 || resourceValue == null || resourceValue == undefined || !props.selectedWorkItems || props.selectedWorkItems.length <= 0) {
            setUpdateGridButtonDisabled(true);
        }
        else {
            setUpdateGridButtonDisabled(false);
        }
    }

    const handleResourceKeyUp = (e: any) => {
        setBulkUpdateResourceSearchValue(e.target.value); 
        setSelectedBulkOperationResource(e.target.value);
    }
    
    useEffect(() => {
        if (workspaceIds.length !== props.selectedWorkSpaceIds.length ||
            workspaceIds.some((v) => !props.selectedWorkSpaceIds.includes(v)) ||
            props.selectedWorkSpaceIds.some((v) => !workspaceIds.includes(v))
        ){
            setWorkspaceIds(props.selectedWorkSpaceIds);
        }
        if (props.selectedWorkSpaceIds.length === 0) {
            setSelectedBulkOperationResource(null);
            setBulkUpdateResourceSearchValue('');
        }
    }, [props.selectedWorkSpaceIds]);

    const setAssignAsPrimaryHandler = (isPrimary: boolean) => {
        setAssignAsPrimary(isPrimary);
        if (!isPrimary) {
            setAssignResourceOnInProgress(false);
        }
    }

    return (
        <>
            <Grid xs={1} sm={1} md={12} lg={12}>
                <h2>Bulk Update Operations</h2>
                <h4>For the selected Work Items, the chosen resource will be designated as the primary if there are no resources for that responsibility.</h4>
            </Grid>

            {/* <Grid xs={1} sm={1} md={6} lg={4}>
                <WorkItemBulkOperationResponsibility
                    idSuffix={props.idSuffix}
                    multiple={true}
                    options={props.responsibilityOptions}
                    onChange={handleResponsibilityChange} />
            </Grid> */}
            <Grid xs={1} sm={1} md={6} lg={4}>
                <WorkItemBulkOperationResource
                    idSuffix={props.idSuffix}
                    resourceValue={selectedBulkOperationResource}
                    onChange={handleBulkOperationChangeResource}
                    onChangeCheckbox={(event: React.ChangeEvent<HTMLInputElement>) => setAssignAsPrimaryHandler(event.target.checked)}
                    checked={assignAsPrimary}  // Control the checked state with your React state
                    loadingResources={loadingBulkOperationsResources}
                    errorResources={errorBulkOperationsResources}
                    disabled={bulkUpdateResourceDisabled}
                    onKeyUp={handleResourceKeyUp}
                    resources={bulkOperationResources}
                    resourceCheckboxLabel='Set as Primary'
                    resourceOnInProgressCheckboxLabel="Reassign In Progress Tasks"
                    checkedForResourceInProgressCheckbox={assignResourceOnInProgress}
                    onChangeForResourceInProgressCheckbox={(event: React.ChangeEvent<HTMLInputElement>) => setAssignResourceOnInProgress(event.target.checked)}
                />
            </Grid>
            <Grid xs={1} sm={1} md={2} lg={2} sx={{ mt: '24px' }}>
                <Button
                    id={"bulk-update-ops-update-grid-"+props.idSuffix}
                    sx={{ marginRight: '10px', height: '40px', textTransform: 'none' }}
                    variant="contained"
                    disabled={updateGridButtonDisabled || props.saveInProgress}
                    onClick={(e) => {
                        if (selectedBulkOperationResource != null && selectedBulkOperationResource && 
                            props.selectedResponsibilityIds !== undefined && props.selectedResponsibilityIds.length > 0) {
                                (selectedBulkOperationResource as GetAutocompleteResult).setAsPrimary = assignAsPrimary;
                                (selectedBulkOperationResource as GetAutocompleteResult).assignOnInProgress = assignResourceOnInProgress
                                props.OnReviewConfirmClick(props.selectedResponsibilityIds, selectedBulkOperationResource);
                        }
                    }}>Review &amp; confirm</Button>
            </Grid>
        </>
    );
}

export default BulkUpdateOpertionsResponsibilities;